module.exports = __webpack_public_path__ + "images/header/header_arrow.svg";